export default {
    name: 'QComments',
    props: {
        comments: {
            type: Array,
            default: () => [],
        },
        showHeading: {
            type: Boolean,
            default: true,
        },
        showNoComments: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        showDate(current, previous) {
            // If there is no previous message with a date to compare,
            // simply return true so we show this message's date.
            if (!previous) {
                return true;
            }

            // Get the current message's date and the previous message's date.
            const currentDate = this.$moment.utc(current.timestamp).local().format('YYYY-MM-DD');
            const previousDate = this.$moment.utc(previous.timestamp).local().format('YYYY-MM-DD');

            // Compare those dates to see if they are the same,
            // and if not, show the new date.
            if (currentDate !== previousDate) {
                return true;
            }

            // By default, do NOT show the message date.
            return false;
        }
    },
};
